export { markdownDocCreateCommand } from './v1/markdowndoc_create';

import { markdownDocCreateCommand } from './v1/markdowndoc_create';

export const markdownDocCommands = [markdownDocCreateCommand];
